import React, { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  Tooltip,
  Typography,
  IconButton
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'

import StoreNotFound from '~/components/StoreNotFound'
import ProductImageThumb from '~/components/ProductImageThumb'
import { useLiterals } from '~/components/Literals'

import track from '~/track'
import { selectPosition } from '~/selectors'

const useStyles = makeStyles(() => ({
  title: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid #E0E0E0'
  }
}))

export default function DialogStyle({ open, handleClose, product, ecommerce }) {
  const classes = useStyles()
  const [position] = useSelector(selectPosition, shallowEqual)
  const { buyOnline, showBuyOnline, showContextViewEstablishment = false } = ecommerce
  const { getLiteral } = useLiterals()

  useEffect(() => {
    if (open) {
      return buyOnline === 'ecommerceGoogle' && Boolean(showBuyOnline)
        ? track('naoLocalizadoProximo', { category: 'menu', name: product && product.name })
        : track('naoLocalizadoProximo-SemEcommerce', {
            category: 'menu',
            name: product && product.name
          })
    }
  }, [open])

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open && !position?.dialogAskPosition}
      onClose={handleClose}
      id="dialog-find-product"
    >
      <DialogTitle className={classes.title} disableTypography>
        <Grid
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: 8
          }}
        >
          <Typography style={{ fontWeight: 500 }}>
            {showContextViewEstablishment ? getLiteral('1993') : getLiteral('2339')}
          </Typography>

          <Tooltip title={getLiteral('1251')} placement="bottom">
            <IconButton aria-label={getLiteral('1251')} size="small" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Grid>

        {!showContextViewEstablishment && (
          <Grid
            container
            alignItems="center"
            wrap="nowrap"
            style={{ padding: 16, borderTop: '1px solid #CCC' }}
          >
            <ProductImageThumb product={{ imageurl: product?.imageurl }} />
            <Typography variant="body1" style={{ marginLeft: 16 }}>
              {product.name}
            </Typography>
          </Grid>
        )}
      </DialogTitle>
      <DialogContent align="center" dividers style={{ backgroundColor: '#EEEBEB' }}>
        <StoreNotFound />
      </DialogContent>
    </Dialog>
  )
}
